import styled from 'styled-components'

export const MainContainer = styled.div`
    display: flex;
    justify-content: start;
    align-items: start;
    flex-flow: column;
    color: #fff;
    font-family: 'Bebas Neue', sans-serif;
    font-size: 1.25rem;
    height: 100%;

    div {
        display: flex;
    }

    @media screen and (min-width: 992px) {
        align-items: center;
        justify-content: center;
    }
`

export const PlaygroundContainer = styled.div`
    flex-flow: column;
    padding: 0 2rem 2rem 2rem;
    overflow-y: auto;
    height: 100%;
`
export const WooferContainer = styled.div`
    margin-top: 2rem;
    display: flex;
    position: relative;
    justify-content: center;
    min-height: 280px;
    height: 100%;
    align-items: center;

    img {
        position: absolute;

        &#skin {
            z-index: 2;
        }

        &#head,
        &#mouth,
        &#eyes {
            z-index: 3;
        }
        &#clothing {
            z-index: 5;
        }
    }
`

export const SubContainer = styled.div`
    background-color: rgba(0, 0, 0, 0.95);
    border-radius: 0.5rem;
    flex-flow: column;
    max-width: 100%;

    @media screen and (min-width: 992px) {
        max-width: 880px;
        height: 850px;
    }

    padding-bottom: 2rem;
    overflow-y: auto;
`

export const SelectContainer = styled.div`
    flex-flow: column;
    min-width: 80%;
    padding: 1.5rem;
    width: 15rem;

    select {
        appearance: none;
        display: grid;
        position: relative;
        background-color: transparent;
        margin: 0;
        width: 100%;
        font-family: inherit;
        font-size: inherit;
        cursor: inherit;
        line-height: inherit;
        color: #ffffffd9;
        border: 1px solid #434343;
        padding: 0.5rem;
        outline: none;
        transition: border-color 0.5s;
        background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23ffffffd9%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');
        background-repeat: no-repeat;
        background-position: right 0.7em top 50%;
        background-size: 0.65em auto;
        &:hover {
            border-color: #0bab7b;
        }
        &:focus {
            border-color: #06fcb2;
        }

        option {
            font-size: 1.25rem !important;
            background-color: #434343;
            font-family: sans-serif;
            font-size: 1rem !important;
        }
    }

    select::after {
        position: absolute;
        content: '';
        width: 0.8em;
        height: 0.5em;
        background-color: #fff !important;
        clip-path: polygon(100% 0%, 0 0%, 50% 100%);
    }

    div:nth-child(3) {
        padding-top: 0.5rem;
    }

    @media screen and (min-width: 576px) {
        min-width: 25%;
    }
`

export const ControlsContainer = styled.div`
    flex-wrap: wrap;
    justify-content: center;
    align-content: end;
`

export const AttributeLabel = styled.div`
    padding-bottom: 0.5rem;
`

export const PageSwitcher = styled.div`
    padding-left: 0.5rem;
    padding-top: 0.75rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #141414;
    z-index: 3;
`

export const PageLink = styled.button<{ active: boolean }>`
    padding: 0;
    border: none;
    font: inherit;
    color: ${(props) => (props.active ? '#06fcb2' : 'inherit')};
    background-color: transparent;
    cursor: pointer;
    margin-right: 1rem;
    padding-left: 1rem;
    transition: color 0.5s;
`

export const RarityContainer = styled.div`
    flex-flow: column;
    padding: 0 2rem 2rem 2rem;
    overflow-y: auto;
`

export const RarityTraitsContainer = styled.div`
    flex-flow: row;
    flex-wrap: wrap;
    justify-content: center;
`

export const RarityAttributeContainer = styled.div`
    flex-flow: column;
    align-items: center;
    padding: 0.5rem;
    background-color: transparent;
`

export const RarityTraitLabelAndImage = styled.div`
    flex-flow: column;
    padding: 0.5rem 0.5rem 0rem 0.5rem;
    align-items: center;
    text-align: center;
    background: rgb(0, 0, 0);
    background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(64, 70, 70, 0.3) 50%,
        rgba(0, 0, 0, 0) 100%
    );

    img {
        width: 100px;
        height: 100px;
        z-index: 3;
    }

    div {
        text-align: center;
        justify-content: center;

        &:first-child {
            margin-top: 0.5rem;
        }
        &:nth-child(2) {
            margin-top: 1rem;
            align-items: center;
        }
        &:nth-child(3) {
            margin-top: 1rem;
        }
        &:nth-child(3),
        &:nth-child(4) {
            font-size: 1.125rem;
        }
    }

    border: 1px solid #141414;
    height: 230px;
`

export const RarityImageContainer = styled.div<{ background: string | null }>`
    width: 100px;
    height: 100px;
    position: relative;
    background-image: ${(props) =>
        props.background ? `url(${props.background})` : 'none'};
    background-size: contain;
    background-repeat: no-repeat;
`

export const RarityAttributeLabel = styled.div`
    padding: 1rem;
    color: #ffffffd9;
    font-size: 1.5rem;
    border-bottom: 1px solid #fff;
    border-top: 1px solid #fff;
    margin-bottom: 2rem;
    margin-top: 1rem;
`
